"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useModalStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    '@keyframes lds-ellipsis1': {
      '0%': {
        transform: 'scale(0)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    '@keyframes lds-ellipsis3': {
      from: {
        transform: 'scale(1)'
      },
      to: {
        transform: 'scale(0)'
      }
    },
    '@keyframes lds-ellipsis2': {
      from: {
        transform: 'translate(0, 0)'
      },
      to: {
        transform: 'translate(19px, 0)'
      }
    },
    ellipsis: {
      display: 'inline-block',
      position: 'relative',
      width: 64,
      height: 64,
      '& div': {
        position: 'absolute',
        top: 27,
        width: 11,
        height: 11,
        borderRadius: '50%',
        backgroundColor: theme.palette.BLUE400,
        animationTimingFunction: 'cubic-bezier(0, 1, 1, 0)',
        '&:nth-child(1)': {
          left: 6,
          animation: '$lds-ellipsis1 0.6s infinite'
        },
        '&:nth-child(2)': {
          left: 6,
          animation: '$lds-ellipsis2 0.6s infinite'
        },
        '&:nth-child(3)': {
          left: 26,
          animation: '$lds-ellipsis2 0.6s infinite'
        },
        '&:nth-child(4)': {
          left: 45,
          animation: '$lds-ellipsis3 0.6s infinite'
        }
      }
    }
  };
});
var _default = useModalStyles;
exports.default = _default;